/**
 * HOME-SURVEYS-SKELETON.WIDGET
 * Skeleton adapté à la carte de l'enquête de home-surveys.widget.tsx : titre et statut, les trois chiffres
 * (taux, invités, effectués) et le bouton des résultats.
 */
import Skeleton from "@/components/skeleton"

export default function HomeSurveysSkeletonWidget() {
  return (
    <div style={{ minHeight: 200 }}>
      <div className="flex" style={{ alignItems: "center" }}>
        <Skeleton width={110} height={18} />
        <div style={{ flex: 1 }} />
        <Skeleton width={140} height={28} borderRadius={14} />
      </div>

      <div className="flex" style={{ marginTop: 28, justifyContent: "space-around" }}>
        {[0, 1, 2].map((i) => (
          <div key={i} className="flex flex-dcol" style={{ alignItems: "center", gap: 6 }}>
            <Skeleton width={90} height={11} />
            <Skeleton width={70} height={11} style={{ marginBottom: 8 }} />
            <Skeleton width={56} height={22} />
          </div>
        ))}
      </div>

      <div className="flex" style={{ marginTop: 28 }}>
        <div style={{ flex: 1 }} />
        <Skeleton width={240} height={44} borderRadius={6} />
      </div>
    </div>
  )
}
